import axios from 'axios';

const axiosPublicInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        get: {
            'x-public-token': process.env.REACT_APP_PUBLIC_TOKEN,
        },
        post: {
            'x-public-token': process.env.REACT_APP_PUBLIC_TOKEN,
        }
    },
});

export default axiosPublicInstance;
